import type { LucideIcon } from "lucide-react";
import { Card, CardContent } from "../../ui/card";

interface ProductInfoGuideProps {
  title: string;
  description: string;
  icon: LucideIcon;
  items: {
    title: string;
    description: string;
    icon: LucideIcon;
  }[];
}

export default function ProductInfoGuide({
  title,
  description,
  icon: Icon,
  items,
}: ProductInfoGuideProps) {
  return (
    <Card className="product-panel product-guide-panel">
      <CardContent className="product-panel-content">
        <div className="product-section-heading">
          <span className="product-icon">
            <Icon aria-hidden="true" />
          </span>
          <div>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
        </div>
        <div className="product-guide-grid">
          {items.map((item) => (
            <div key={item.title} className="product-guide-item">
              <item.icon aria-hidden="true" />
              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
